
<script>
import pdfFile01 from '@/assets/pdf/01.pdf';
import pdfFile02 from '@/assets/pdf/02.pdf';
import pdfFile03 from '@/assets/pdf/03.pdf';

export default {
  name: 'LayerPopupNotice',
  data() {
    return {
      isTodayChecked: false
    };
  },
  mounted() {
    this.layerOpen();
  },
  methods: {
    layerOpen() {
      const cookiedata = document.cookie;
      const $layerPop = document.querySelector('.layer-popup');
      if (cookiedata.indexOf('todayCookie=done') < 0) {
        $layerPop.classList.add('layer-open');
      } else {
        $layerPop.classList.remove('layer-open');
      }
    },
    layerClose() {
      const $layerPop = document.querySelector('.layer-popup');
      if (this.isTodayChecked) {
        this.setCookie('todayCookie', 'done', 1);
      } else {
        this.setCookie('todayCookie', '', 1);
      }
      $layerPop.classList.remove('layer-open');
    },
    setCookie(name, value, expiredays) {
      const todayDate = new Date();
      todayDate.setDate(todayDate.getDate() + expiredays);
      document.cookie = `${name}=${escape(value)}; path=/; expires=${todayDate.toGMTString()};`;
    },
    downloadPDF01() {
      // import를 사용하여 PDF 파일 경로 가져오기
      const pdfPath = pdfFile01;
      this.downloadFile(pdfPath, '1. 변경 전 이용약관 전문(2025.01.02).pdf');
    },
    downloadPDF02() {
      const pdfPath = pdfFile02;
      this.downloadFile(pdfPath, '2. 신구조문 대비표.pdf');
    },
    downloadPDF03() {
      const pdfPath = pdfFile03;
      this.downloadFile(pdfPath, '3. 개정된 이용약관 전문(2025.05.02).pdf');
    },
    downloadFile(path, filename) {
      // 동적으로 다운로드 링크 생성
      const link = document.createElement('a');
      link.href = path;
      link.download = filename;
      link.click();
    }
  }
};
</script>

<template>
  <div class="layer-popup">
    <div class="layer-container">
      <h2>공지사항</h2>
      <div class="notice-content">
        <h3>[공지] 이용약관 개정 안내(2025.04.02)</h3>
        <div class="intro-text">
          <p>안녕하세요. 기프티엘입니다.</p>
          <p>기프티엘을 이용해 주시는 고객님께 감사드리며, 전자금융거래 이용약관 변경 안내들 드립니다.</p>
          <p>자세한 정보는 하단에 기재해드린 내용을 참고해주시기 바랍니다.</p>
        </div>
        <div class="content-scroll">
          <section>
            <h4>공지 일자</h4>
            <div class="pl4">
              <p>- 2025년 4월 02일(수)</p>
            </div>
          </section>
          <section>
            <h4>시행 일자</h4>
            <div class="pl4">
              <p>- 2025년 5월 02일(금)</p>
            </div>
          </section>
          <section>
            <h4>변경 사유</h4>
            <div class="pl4">
              <p>- 전자금융거래법 개정(2024.9)에 따른 이용약관 수정 및 현행화</p>
            </div>
          </section>
          <section>
            <h4>개정 항목</h4>
            <div class="pl4">
              <p>- 첨부문서 '2. 신구조문대비표' 및 '3. 개정된 이용약관 전문(2025.05.02)' 참조</p>
            </div>
          </section>
          <section>
            <h4>이의제기 및 관련 문의</h4>
            <div class="pl4">
              <div class="section-item">
                <p>- 개정된 이용약관에 동의하지 않으시는 경우 회원 탈퇴를 요청하실 수 있습니다.</p>
                <p>- 시행일까지 별도의 탈퇴 의사를 표시하지 않는 경우에는 개정에 동의하신 것으로 간주하여 시행일로부터 개정된 이용약관이 적용됩니다.</p>
                <p>- 개정과 관련된 문의는 고객센터를 통해 접수해 주시기 바랍니다.</p>
              </div>
            </div>
          </section>
          <section>
            <h4>첨부문서</h4>
            <div class="pl4">
              <div class="section-item">
                <button @click="downloadPDF01">1. 변경 전 이용약관 전문(2025.01.02)</button>
                <button @click="downloadPDF02">2. 신구조문대비표</button>
                <button @click="downloadPDF03">3. 개정된 이용약관 전문(2025.05.02)</button>
              </div>
            </div>
          </section>
          <section class="footer-text">
            <p>앞으로도 고객님께 더욱 좋은 서비스를 제공하기 위하여 최선의 노력을 다하겠습니다.</p>
            <p>감사합니다.</p>
          </section>
        </div>
        <div class="today-area">
          <input v-model="isTodayChecked" type="checkbox" id="todayWindow">
          <label for="todayWindow">오늘 하루 동안 열지 않음</label>
        </div>
      </div>
      <button type="button" class="layer-close" @click="layerClose"></button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.layer-popup {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  border: 2px solid #000;
  background: #fff;
  z-index: 1000;
  &.layer-open {
    display: block;
  }
}

.layer-container {
  position: relative;
  padding: 20px;
  h2 {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
  }
  h3 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
  }
}

.content-scroll {
  max-height: 50vh;
  overflow-y: auto;
  padding-right: 10px;
  margin: 15px 0;
  section {
    margin-bottom: 20px;
    h4 {
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
}

.pl4 {
  padding-left: 15px;
}

.section-item {
  margin-bottom: 15px;
  p {
    margin: 5px 0;
    line-height: 1.5;
  }
}

.today-area {
  margin: 20px 0;
  input[type="checkbox"] {
    width: 15px;
    height: 15px;
    vertical-align: middle;
    margin-right: 5px;
  }
  label {
    vertical-align: middle;
  }
}

.layer-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  background: none;
  border: none;
  cursor: pointer;
  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 2px;
    background: #000;
  }
  &:before {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  &:after {
    transform: translate(-50%, -50%) rotate(45deg);
  }
}

@media (max-width: 768px) {
  .layer-popup {
    width: 95%;
  }
  .content-scroll {
    max-height: 60vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PopupNotice.vue